// Tracks a "generation" per key so an async write that started before the key's data was
// invalidated can recognise its own eventual response as stale and skip writing it — instead of
// resurrecting exactly the cache entry the invalidation was meant to clear.
//
// Extracted as its own module (rather than living inline in a context) so the race it guards
// against — invalidate() firing while a start()'d request is still in flight — can be exercised
// directly in a unit test, without rendering a component or awaiting a real request.
export function createStaleResponseGuard() {
    const generations = {};

    return {
        // Call before starting the async work, and hold on to the return value to pass to
        // isCurrent() once it resolves.
        start(key) {
            return generations[key] || 0;
        },
        // Call whenever a key's data changes independently of any request already in flight for
        // it (e.g. a mutation elsewhere makes that request's eventual answer stale).
        invalidate(key) {
            generations[key] = (generations[key] || 0) + 1;
        },
        // True if nothing invalidated `key` since `start(key)` returned `startedGeneration` —
        // safe to apply the response. False means it raced an invalidation and must be dropped.
        isCurrent(key, startedGeneration) {
            return (generations[key] || 0) === startedGeneration;
        }
    };
}
